import MerchantWhitelistInAccordion from './MerchantWhitelistInAccordion';

export default MerchantWhitelistInAccordion;